const STEPS = [
  { label: "相談", desc: "公開予定日と内容をヒアリング" },
  { label: "内容整理・見積もり", desc: "掲載内容と費用を整理" },
  { label: "制作・確認", desc: "デザインを確認しながら制作" },
  { label: "公開", desc: "表示を確認してサイトを公開" },
];

export default function Flow() {
  return (
    <section id="flow" className="scroll-mt-20 bg-cream py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600">Process</p>
          <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-navy-950 md:text-5xl">
            ご相談から公開まで。
          </h2>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <div key={step.label} className="relative">
              {i < STEPS.length - 1 && (
                <span
                  className="absolute -right-3 top-7 hidden text-2xl text-navy-200 lg:block"
                  aria-hidden="true"
                >
                  <i className="ri-arrow-right-line" />
                </span>
              )}
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-lime-400 font-heading text-xl font-black text-navy-950">
                {i + 1}
              </div>
              <h3 className="mt-5 font-heading text-lg font-black text-navy-950">{step.label}</h3>
              <p className="mt-2 text-sm leading-relaxed text-navy-600">{step.desc}</p>
            </div>
          ))}
        </div>

        <p className="mt-10 text-sm text-navy-500">
          公開希望日と制作内容を確認し、対応可能なスケジュールをご案内します。
        </p>
      </div>
    </section>
  );
}